import { ProductNearByDTO } from 'app/model/products/product-nearby-dto.model';
import { PoiLocation } from 'app/model/search-form-model';
import { Paginate } from './product-poi-payload';

export class ProductNearByPayload {
    langId: String;
    currencyId: Number;
    categoryId: Number;
    productId: Number;
    destinationId: Number;
    filter: FilterNearBy;
    poi: PoiLocation;
    companyId: number;

    constructor(productNearBy: ProductNearByDTO = undefined) {
        if (productNearBy) {
            this.langId = productNearBy.langId;
            this.categoryId = 3;
            this.currencyId = 1;
            this.productId = productNearBy.productId;
            this.destinationId = productNearBy.destinationId;
            this.filter = new FilterNearBy(productNearBy);
            this.poi = new PoiLocation(productNearBy.latitude.valueOf(), productNearBy.longitude.valueOf());
        }
    }
}

export class FilterNearBy {
    distance: Number;
    priceRange: PriceRange;
    checkIn: String;
    checkOut: String;
    rooms: Room[];
    pagination: Paginate;
    sort: Sort;

    constructor(productNearBy: ProductNearByDTO = undefined) {
        if (productNearBy) {
            this.distance = productNearBy.radius;
            this.priceRange = productNearBy.priceRange;
            this.checkIn = productNearBy.checkIn;
            this.checkOut = productNearBy.checkOut;
            this.rooms = productNearBy.rooms;
            this.pagination = new Paginate();
            this.sort = new Sort();
        }
    }
}

export class PriceRange {
    min: Number;
    max: Number;
    constructor(min: Number = undefined, max: Number = undefined) {
        this.min = min;
        this.max = max;
    }
}

export class Room {
    adult: Number;
    children: Number[];
}

export class Sort {
    poiDistance: Boolean;
    constructor(poiDistance: Boolean = true){
        this.poiDistance = poiDistance;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/products/payload/product-nearby-payload.ts